// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { withRouter } from 'react-router-dom';
import DashboardIcon from '../icons/DashboardIcon';
import workOrderStatusControl from '../../../utils/workOrderStatusControl';

const toggleCheckbox = (workOrder, selected, select) => {
  if (workOrder.status === 'completed') ;
  const id = workOrder._id;
  if (selected.includes(id)) {
    return select(selected.filter((el) => el !== id));
  }
  return select([...selected, id]);
};


const ControlsButton = ({
  workOrder,
  setCurrentWorkOrder,
  selectedWorkOrders,
  selectWorkOrder,
  fetchApplicantsForWorkOrder,
  toggleModal,
  publishWorkOrder,
  history,
  match,
  createWorkOrderTemplateByWorkOrder,
}) => {
  const workOrderControlByStatus = workOrder ? workOrderStatusControl(workOrder.status) : {};

  const handlerCreateTemplate = () => {
    const saveCopy = name => {
      createWorkOrderTemplateByWorkOrder(name, workOrder._id);
    };
    toggleModal(true, 'confirmModal', true, {
      onAccept: saveCopy,
      header: 'Create template by Work Order',
      inputLabel: 'Name',
      buttonLabels: { reject: 'Cancel' },
    });
  };

  return (
    <>
      <button
        type="button"
        className="wo-btn wo-btn--duplicate"
        onClick={() => {
          toggleModal(true, 'copyWorkOrderModal', false, { workOrderId: workOrder._id });
        }}
      >
        <DashboardIcon name="duplicate" size={16} strokeWidth="2" />
        Duplicate
      </button>
      {/* <label className="check_btn">
        <input
          type="checkbox"
          id={`checkbox4${workOrder._id}`}
          checked={selectedWorkOrders.includes(workOrder._id)}
          onChange={() => {
            toggleCheckbox(workOrder, selectedWorkOrders, selectWorkOrder);
          }}
        />
      </label> */}
      <button
        type="button"
        className="wo-btn wo-btn--details"
        onClick={() => {
          setCurrentWorkOrder(workOrder);
          toggleModal(true, 'viewDetailsWorkOrderModal', true, { id: workOrder._id });
          const { tab } = match.params;
          const pathname = tab ? `/dashboard/${tab}` : '/dashboard';
          history.replace({
            pathname,
            search: `?type=work-order&id=${workOrder._id}`,
          });
        }}
      >
        Details
      </button>
      {workOrderControlByStatus.draft && (
        <button
          type="button"
          className="wo-btn wo-btn--details"
          onClick={() => publishWorkOrder(workOrder._id)}
        >
          Publish
        </button>
      )}
      {workOrderControlByStatus.beforeAssigned && !workOrderControlByStatus.canceled && (
        <>
          {(!workOrderControlByStatus.draft || workOrder.routedStatus) && (
            <button
              type="button"
              className="wo-btn wo-btn--details"
              onClick={() => {
                fetchApplicantsForWorkOrder(workOrder._id);
                setCurrentWorkOrder(workOrder);
                toggleModal(true, 'viewAllApplicantsForWorkOrderModal');
              }}
            >
              View Applicants
            </button>
          )}
          <button
            type="button"
            className="wo-btn wo-btn--details"
            onClick={() => {
              setCurrentWorkOrder(workOrder);
              fetchApplicantsForWorkOrder(workOrder._id);
              toggleModal(true, 'nearByContractorModal');
            }}
          >
            Contractors Near-by
          </button>
        </>
      )}
      <button
        type="button"
        className="wo-btn wo-btn--template"
        onClick={handlerCreateTemplate}
      >
        <DashboardIcon name="plus" size={16} strokeWidth="2" />
        Create Template
      </button>
    </>
  );
};

export default withRouter(ControlsButton);
